/**
 * 时间格式化工具函数
 */

/**
 * 将UTC时间字符串格式化为本地时区的显示格式
 * @param dateString - ISO 时间字符串或时间戳
 * @param options - 格式化选项
 * @returns 格式化后的时间字符串
 */
export const formatDateTime = (
  dateString: string | number | Date,
  options?: {
    showSeconds?: boolean;
    showDate?: boolean;
    showTime?: boolean;
    locale?: string;
  }
): string => {
  if (!dateString) return '-';

  const {
    showSeconds = true,
    showDate = true,
    showTime = true,
    locale = 'zh-CN'
  } = options || {};

  try {
    const date = new Date(dateString);
    
    // 检查日期是否有效
    if (isNaN(date.getTime())) {
      return '-';
    }

    const formatOptions: Intl.DateTimeFormatOptions = {};

    if (showDate) {
      formatOptions.year = 'numeric';
      formatOptions.month = '2-digit';
      formatOptions.day = '2-digit';
    }

    if (showTime) {
      formatOptions.hour = '2-digit';
      formatOptions.minute = '2-digit';
      if (showSeconds) {
        formatOptions.second = '2-digit';
      }
      formatOptions.hour12 = false; // 使用24小时制
    }

    // 自动转换为本地时区
    return new Intl.DateTimeFormat(locale, formatOptions).format(date);
  } catch (error) {
    console.error('时间格式化失败:', error);
    return '-';
  }
}; 